import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2768 8.08698C12.5677 8.28548 12.5677 8.71452 12.2768 8.91302L1.72411 16.1134C1.39222 16.3398 0.942303 16.1021 0.942303 15.7003L0.942304 1.29966C0.942304 0.897872 1.39222 0.660187 1.72411 0.886645L12.2768 8.08698Z"
      stroke="currentColor"
    />
  </svg>,
  "ArrowPreviousMapCarousel"
);
